import { Component, OnInit,  DoCheck, ViewChild, AfterViewInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SedsColorMode, SedsTimerComponent, SedsTimerModule } from 'experian-design-system';
import { AuthUtils } from 'src/app/shared/util/auth.utils';
import { DateUtils } from 'src/app/shared/util/date-utils';
import { AuthUserService } from 'src/app/core/apis/auth/auth-user.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { SessionService } from 'src/app/core/service/session.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: true,
    imports: [RouterLink, NgIf, MatButtonModule, MatMenuModule, SedsTimerModule]
})
export class HeaderComponent implements OnInit, DoCheck, AfterViewInit {

  usuario;
  cargo;
  email;

  colorDark = SedsColorMode.DEFAULT_DARK;
  colorLight = SedsColorMode.DEFAULT_LIGHT;

  @ViewChild('timer')
  timer!: SedsTimerComponent;

  constructor(public auth: AuthUserService,
    private sessionService: SessionService,
    public dialog: MatDialog
  ) {}

  ngDoCheck(){
    this.updateUser();
    this.updateCargo();
  }

  ngOnInit() {
    this.updateUser();
    this.updateCargo();
  }

  ngAfterViewInit(): void {
    this.loadSessionTime();
    this.sessionService.sessionTimeUpdated$.subscribe(() => {
      this.loadSessionTime();
    });
  }

  updateCargo(){
    this.cargo = sessionStorage.getItem('cargo');
  }

  updateUser(){
    this.usuario = JSON.parse(sessionStorage.getItem('usuario'));
  }

  timeOver(event){
    const token = sessionStorage.getItem("JWTToken");
    if(token && AuthUtils.isTokenExpired(token)) {
      this.openDialog();
    }
  }

  public openDialog(): void {
    const data = {
      messages: ['Sua sessão expirou!', 'Faça o login novamente'],
      confirmText: 'OK',
      cancelText: 'Voltar'
    };

    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
        window.location.href = "/logout";
    });
  }

  private loadSessionTime() {
    const token = sessionStorage.getItem("JWTToken");
    if (token) {
      const currentTime = new Date();
      const tokenExpiresIn = (AuthUtils._getTokenExpirationDate(token) || new Date());
      const sessionTime = Math.floor(DateUtils.diffInMinutes(currentTime, tokenExpiresIn))
      this.timer?.start(sessionTime);
    }
  }

}
